import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
interface PlanoCurricularDisciplina {
  id: string;
  nome: string;
  sigla: string;
  planoCurricularId: string;
  unidadeOrganicaId: string;
  anoLectivoId: string;
  semestre: number;
  tipoDisciplina: string; // 'obrigatoria' | 'optativa'
  cargaHoraria: number;
}
@Injectable({
  providedIn: 'root'
})
export class PlanoCurricularDisciplinaService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all Plano Curricular Disciplina
  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: PlanoCurricularDisciplina[] }>(`${this.path}/getAllPlanoCurricularDisciplina`, params ? new HttpParams({
      fromObject: params
    }) : this.params).pipe(
      map(response => response)
    );
  }

  // Get Plano Curricular Disciplina by ID
  public show(id: string): Observable<PlanoCurricularDisciplina> {
    return this.apiService.get<{ object: PlanoCurricularDisciplina }>(`${this.path}/getPlanoCurricularDisciplinaById/${id}`).pipe(
      map(response => response.object as PlanoCurricularDisciplina)
    );
  }

  // Create new Plano Curricular Disciplina
  public store(planoCurricularDisciplina: PlanoCurricularDisciplina): Observable<PlanoCurricularDisciplina> {
    return this.apiService
      .post<{ object: PlanoCurricularDisciplina }>(`${this.path}/AddPlanoCurricularDisciplina`, planoCurricularDisciplina)
      .pipe(
        map((response) => response.object as PlanoCurricularDisciplina)
      );
  }

  // Update existing Plano Curricular Disciplina
  public update(planoCurricularDisciplina: PlanoCurricularDisciplina): Observable<PlanoCurricularDisciplina> {
    return this.apiService
      .put<{ object: PlanoCurricularDisciplina }>(`${this.path}/UpdatePlanoCurricularDisciplina`, planoCurricularDisciplina)
      .pipe(
        map((response) => response.object as PlanoCurricularDisciplina)
      );
  }

  // Delete existing Plano Curricular Disciplina
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeletePlanoCurricularDisciplinaById/${id}`);
  }
}
